import React from "react";
import ChooseWebsiteTriggerDrawer from "./ChooseWebsiteTriggerDrawer";

// Triggers of a WhatsApp Web workflow (the contact's browser chat, same contact as their WhatsApp). The names must match what
// services/workflow/workflow.triggers.js looks for with channel "whatsapp_web":
//   "Contact opens WhatsApp Web link"          -> handleWhatsappWebLinkOpenedWorkflow (once, on the first open of a link)
//   "First incoming WhatsApp Web message"      -> handleIncomingMessageWorkflow, platform "whatsapp_web" (+ keywords, expiry)
//   "When contact is closed"                   -> handleCloseConversationWorkflow, while a link is active
// The two WhatsApp ones are not offered here: the official WhatsApp workflows are suppressed while a link is active.
const WHATSAPP_WEB_TRIGGERS = [
  {
    id: "contact-opens-whatsapp-web-link",
    name: "Contact opens WhatsApp Web link",
    description:
      "Runs when a contact opens the WhatsApp Web link.",
    triggerType: "root",
    category: "Contact",
    config: [],
  },
  {
    id: "first-incoming-whatsapp-web-message",
    name: "First incoming WhatsApp Web message",
    description:
      "When a contact sends their first message in the WhatsApp Web chat.",
    triggerType: "root",
    category: "Message",
    config: [
      {
        name: "Conditions",
        fields: [
          { label: "Trigger when", type: "select", options: ["Any first message", "When message contains keywords"] },
          { label: "Keywords (comma-separated)", type: "text", description: "Optional. Only trigger when the first message contains one of these keywords." },
        ],
      },
      // Read server-side by workflow.expiry.js's handleExpiry (labels must match exactly)
      {
        name: "Select Time Interval",
        fields: [
          { label: "Select Interval Duration", type: "number", selectedValue: 1, description: "Workflow expires after this duration if no reply (0 = no expiry)." },
          { label: "Select Duration Type", type: "select", options: ["Minutes", "Hours", "Days"], selectedValue: "Days" },
          { label: "Timezone", type: "select", options: ["timezones"], description: "Timezone for expiry." },
        ],
      },
    ],
  },
  {
    id: "when-contact-closed",
    name: "When contact is closed",
    description: "When a teammate closes the conversation",
    triggerType: "root",
    category: "Contact",
    config: [],
  },
];

/** Same drawer, save flow and field editors as the website chat trigger drawer, with the WhatsApp Web triggers. */
const ChooseWhatsappWebTriggerDrawer = (props) => (
  <ChooseWebsiteTriggerDrawer {...props} triggers={WHATSAPP_WEB_TRIGGERS} title="Choose a WhatsApp Web trigger" />
);

export { WHATSAPP_WEB_TRIGGERS };
export default ChooseWhatsappWebTriggerDrawer;
